import { ReactElement, ReactNode, useState } from "react";
import Sidebar from "./sidebar";
import Header from "./header";

interface AppContainerProps {
  children: ReactNode;
  title?: string;
  description?: string;
  showButton?: boolean
  button?: ReactElement | undefined;
  searchBar?: ReactElement | undefined;
}

export function AppContainer({ children, title, description, button, searchBar }: AppContainerProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleSidebarToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="h-screen bg-gray-900 text-white p-4 flex gap-8 overflow-hidden min-h-0">
      <Sidebar isCollapsed={isCollapsed} />

      <div className="flex flex-col flex-1 gap-4 overflow-hidden">
        <Header onSidebarToggle={handleSidebarToggle} />

        <div className="border-l-2 border-purple-500 pl-4 flex items-center justify-between flex-shrink-0">
          <div>
            <h1 className="text-xl font-semibold text-white mb-1">
              {title}
            </h1>
            <p className="text-gray-400 text-xs">
              {description}
            </p>
          </div>

          <div className="flex items-center gap-4">
            {searchBar && searchBar}
            {button && button}
          </div>
        </div>

        <main className="flex-1 scrollbar-hide overflow-y-auto rounded-2xl shadow-lg relative">
          {children}
        </main>
      </div>
    </div>
  );
}
